import Vue from 'vue'
import GallerySlideshow from "./GallerySlideshow.vue";

Vue.component('GallerySlideshow', GallerySlideshow)
